/* eslint import/prefer-default-export:0 */
export const SORT_VIEW = {
	stationID: 'stationID',
	gap: 'gap',
	comments: 'comments'
};